import StruggleCommunication from '~/pages/communication/struggle/libs/components/StruggleCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const StruggleCommunicationPage = (props: TPageProps) => (
  <StruggleCommunication {...props} />
)

export default StruggleCommunicationPage
